import { useNavigate } from "react-router-dom";
import * as React from "react";

import {
  FolderOpenOutlined,
  AccountBalanceOutlined,
} from "@mui/icons-material";
import { Paper, Typography } from "mpulse-design-system";
import { styled, Grid, Divider } from "@mui/material";

import AccountCardDetails from "./AccountCardDetails";

const AccountCard = (props) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/account/${props.account.id}`);
  };

  return (
    <PaperStyled variant="elevation" onClick={handleCardClick}>
      <Grid container rowSpacing={2}>
        <Grid item xxs={12}>
          <Typography variant="h3" color="textPrimary">
            {props.account.name}
          </Typography>
        </Grid>
        <Grid item xxs={12}>
          <Divider />
        </Grid>
        <Grid item container xxs={12}>
          <AccountCardDetails
            Icon={FolderOpenOutlined}
            fetching={props.fetchingAudioFileInfo}
            totalItemTitle="Audio Files"
            totalItemCount={
              props.fetchingAudioFileInfo ? null : props.accountAudio.total
            }
            firstItemTitle="Audio Ready for Review"
            firstItemCount={
              props.fetchingAudioFileInfo
                ? null
                : props.accountAudio.status.readyForReview.total
            }
            secondItemTitle="Waiting for Voice Talent"
            secondItemCount={
              props.fetchingAudioFileInfo
                ? null
                : props.accountAudio.status.readyForRecording.total
            }
          />
          <Grid
            item
            container
            sm
            justifyContent="center"
            sx={{
              position: "relative",
              top: (theme) => `-${theme.spacing(2)}`,
            }}
          >
            <Divider
              sx={{ paddingBottom: (theme) => theme.spacing(2.5) }}
              orientation="vertical"
            />
          </Grid>
          <AccountCardDetails
            Icon={AccountBalanceOutlined}
            fetching={props.fetchingMetadataInfo}
            totalItemTitle={`${props.account.metadataLabel}s`}
            totalItemCount={
              props.fetchingMetadataInfo ? null : props.accountMetadata.total
            }
            firstItemTitle={`${props.account.metadataLabel}s Added Last Month`}
            firstItemCount={
              props.fetchingMetadataInfo
                ? null
                : props.accountMetadata.status.new.total
            }
            secondItemTitle={`${props.account.metadataLabel}s in Draft`}
            secondItemCount={
              props.fetchingMetadataInfo
                ? null
                : props.accountMetadata.status.draft.total
            }
          />
        </Grid>
      </Grid>
    </PaperStyled>
  );
};

const PaperStyled = styled(Paper)(({ theme }) => ({
  "&.MuiPaper-root": {
    cursor: "pointer",
    minHeight: "225px",
    padding: `${theme.spacing(2.5)}`,
    display: "flex",
    flexDirection: "column",
  },
}));

export default AccountCard;
